// ### RememberedProvider
//
// Uses Store to save your last successfully authenticated provider.

'use strict';

var _logger = require('./logger');
var Store = require('./store');


var RememberedProvider = {
	storeKey : 'cvp.auth.rememberedProvider',

	forget : function () {
		_logger.debug('[RememberedProvider] forgetting provider...');
		return Store.remove(this.storeKey);
	},

	get : function () {
		return Store.get(this.storeKey);
	},

	save : function (value) {
		_logger.debug('[RememberedProvider] saving provider...', value);
		return Store.set(this.storeKey, value);
	}
};


module.exports = RememberedProvider;
